// src/logger.js
// A tiny logger helper

export const logEvent = (type, message, details = {}) => {
  const timestamp = new Date().toISOString();
  console.log(`[${timestamp}] [${type.toUpperCase()}] ${message}`, details);
};
